/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import {
    Error400CodeEnum,
    Error404CodeEnum,
    Error405CodeEnum,
    Error500CodeEnum,
    ErrorDefaultCodeEnum,
} from 'client-code/branding-ui-bundle';
import { ErrorTypes } from './ErrorTypes';
import { PreSignInError } from './PreSignInError';

export class MsoDefaultBrandingError extends PreSignInError {
    TAG: string = 'MsoDefaultBrandingError';

    constructor(message: string, code: string) {
        super(code, message);
        this.setCode(code);
    }

    private setCode(code: string): void {
        switch (code) {
            case ErrorDefaultCodeEnum.ApigwError:
                this.code = ErrorTypes.MSO_DEFAULT_BRANDING_APIGW_ERROR_C201;
                this.type = ErrorDefaultCodeEnum.ApigwError;
                break;
            case Error400CodeEnum.BadRequest:
                this.code = ErrorTypes.MSO_DEFAULT_BRANDING_BAD_REQUEST_C202;
                this.type = Error400CodeEnum.BadRequest;
                break;
            case Error404CodeEnum.ResourceNotFound:
                this.code = ErrorTypes.MSO_DEFAULT_BRANDING_RESOURCE_NOT_FOUND_C205;
                this.type = Error404CodeEnum.ResourceNotFound;
                break;
            case Error405CodeEnum.MethodNotAllowed:
                this.code = ErrorTypes.MSO_DEFAULT_BRANDING_METHOD_NOT_ALLOWED_C204;
                this.type = Error405CodeEnum.MethodNotAllowed;
                break;
            case Error500CodeEnum.InternalServerError:
                this.code = ErrorTypes.MSO_DEFAULT_BRANDING_INTERNAL_SERVER_ERROR_C203;
                this.type = Error500CodeEnum.InternalServerError;
                break;
            default:
                this.code = ErrorTypes.MSO_DEFAULT_BRANDING_UNKNOWN_ERROR_C299;
                this.type = 'MSO_DEFAULT_BRANDING_UNKNOWN_ERROR';
        }
    }
}
